var exports = {
  "zr": "x620889e6--a4f735--root",
  "h_": "x620889e6--a4f735--description",
  "Al": "x620889e6--a4f735--amenities",
  "IM": "x620889e6--a4f735--amenities-group",
};

module.exports = exports;
